import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { fieldInputCls } from "@/components/Field";
import { useT } from "@/lib/i18n";

export const TrackSelect = ({ tracks, value, onChange, testid, className = "" }) => {
  const { t } = useT();
  return (
    <Select value={value || "none"} onValueChange={(v) => onChange(v === "none" ? null : v)}>
      <SelectTrigger data-testid={testid} className={`${fieldInputCls} ${className}`}><SelectValue /></SelectTrigger>
      <SelectContent>
        <SelectItem value="none">{t("none")}</SelectItem>
        {tracks.map((tr) => (
          <SelectItem key={tr.id} value={tr.id} data-testid={`${testid}-option-${tr.id}`}>
            {tr.name}{tr.city ? ` · ${tr.city}` : ""}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
